// SPDX-FileCopyrightText: (C) 2023 Jason Ish <jason@codemonkey.net>
// SPDX-License-Identifier: MIT

import { createSignal } from "solid-js";

export const [IS_AUTHENTICATED, SET_IS_AUTHENTICATED] = createSignal(false);
